import { render, staticRenderFns } from "./PFSettlementApprovalSection.vue?vue&type=template&id=2bcf7180"
import script from "./PFSettlementApprovalSection.vue?vue&type=script&lang=js"
export * from "./PFSettlementApprovalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports